import { memo } from "react"

export const HeroScrollHint = memo(function HeroScrollHint() {
  return (
    <div
      className="pointer-events-none absolute inset-x-0 bottom-6 flex flex-col items-center gap-1.5 text-mesa-primary/30 motion-safe:animate-float-in motion-safe:[animation-delay:900ms] md:bottom-8"
      aria-hidden="true"
    >
      <span className="h-8 w-px bg-linear-to-b from-transparent to-mesa-primary/35" />
      <span className="h-1 w-1 rounded-full bg-mesa-primary/45 motion-safe:animate-pulse-dot" />
    </div>
  )
})
